import { setClientId } from '../State/lastThreeMonthsReport';
import fetchLastThreeMonthsReport from '../Services/fetchLastThreeMonthsReport';

export default (value) => async (dispatch) => {
  dispatch(setClientId(value));
  dispatch(fetchLastThreeMonthsReport());
}
